var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tabs',{attrs:{"parent":"bank_payment_list"}},[_c('tab',{attrs:{"id":"payments","name":_vm.translate('bank_payment.payments'),"href":_vm.url + '/payments'}},[_c('keep-alive',[_c('Payments')],1)],1),_c('tab',{attrs:{"id":"imports","name":_vm.translate('bank_payment.import_history.title'),"href":_vm.url + '/imports'}},[_c('Imports')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }